import { render, staticRenderFns } from "./Vitec.vue?vue&type=template&id=a2acdaf6"
import script from "./Vitec.vue?vue&type=script&lang=js"
export * from "./Vitec.vue?vue&type=script&lang=js"
import style0 from "./Vitec.vue?vue&type=style&index=0&id=a2acdaf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports